import { useSortBy } from 'react-instantsearch';
import Expand from '@monofront/design-system/visuals/Icons/Old/Expand';
import { useTranslations } from 'next-intl';
import Filter from '@monofront/design-system/visuals/Icons/Filter';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';
interface ISelectSortProps {
  items: Array<{
    count: number;
    isRefined: boolean;
    label: string;
    value: string;
  }>;
  refine: (refinement: string) => void;
  setIsCustomSort: (arg: boolean) => void;
}

const SelectSort: React.FC<ISelectSortProps> = ({
  items,
  refine,
  setIsCustomSort,
}) => {
  const tCatalog = useTranslations('Catalog');

  return (
    <>
      <div className="container">
        <select
          onChange={(event) => {
            event.preventDefault();

            if (event.target.value === 'hasCustomSort') {
              setIsCustomSort(true);
              refine('preprod_products');

              return;
            }

            setIsCustomSort && setIsCustomSort(false);
            refine(event.target.value);
          }}
          data-testid="SelectSort-select-1"
        >
          {items.map((item) => {
            return (
              <option
                value={item.value}
                key={item.value}
                data-testid={`SelectSort-option-${item.value}`}
              >
                {tCatalog('sortBy')} {item.label}
              </option>
            );
          })}
        </select>
        <div className="icon-desktop">
          <Expand width={32} height={32} />
        </div>
        <div className="icon-mobile">
          <Filter size={IconSizes.sm} />
          <span className="tw-ml-2">{tCatalog('sort')}</span>
        </div>
      </div>
      <style jsx>{`
        .container {
          position: relative;
        }

        select {
          appearance: none;
        }

        .icon-desktop {
          pointer-events: none;
          display: block;
          position: absolute;
          right: 10px;
          top: 7px;
        }

        .icon-mobile {
          display: none;
        }

        @media (max-width: 800px) {
          .container {
            min-height: 32px;
          }

          .icon-desktop {
            display: none;
          }

          .icon-mobile {
            top: 0;
            display: flex;
            position: absolute;
            align-items: center;
            min-height: 32px;
            pointer-events: none;
          }

          select {
            outline: none;
            height: 100%;
            color: transparent;
            background-color: transparent;
            border: none;
          }
        }
      `}</style>
    </>
  );
};

const SelectSortBy = connectSortBy(SelectSort);

export default SelectSortBy;

// TODO (Codemod generated): ensure your usage correctly maps the props from the connector to the hook
function connectSortBy(Component) {
  const SortBy = (props) => {
    const data = useSortBy(props);

    return <Component {...props} {...data} />;
  };

  return SortBy;
}
